<template>
  <div class="SettingPanel" >
    <el-card class="box-card">
      <div class="text item">
        <el-row>
          <el-col class="title"><div class="grid-content bg-purple-dark">服务管理</div></el-col>
        </el-row>
        <el-row class="button-line">
          <el-button plain @click.native="$router.push('service_list')">服务名称</el-button>
          <el-button plain @click.native="$router.push('tctype_list')">套餐类型</el-button>
          <el-button plain @click.native="$router.push('dptype_list')">单品类型</el-button>
          <el-button plain @click.native="$router.push('ddtype_list')">订单类型</el-button>
          <el-button plain @click.native="$router.push('sjzctype_list')">实际注册类型</el-button>
          <el-button plain @click.native="$router.push('hygltype_list')">行业管理</el-button>
          <el-button plain @click.native="$router.push('tkreason_list')">退款原因</el-button>
          <el-button plain @click.native="$router.push('khfrom_list')">客户来源</el-button>
          <el-button plain @click.native="$router.push('noneed_list')">套餐不需要原因</el-button>
        </el-row>
        <el-row class="button-line">
          <el-button plain @click.native="$router.push('value_added')">增值服务管理</el-button>
          <el-button plain @click.native="$router.push('service_provider')">B端商户管理</el-button>
          <el-button plain @click.native="$router.push('company_park')">公司园区管理</el-button>
          <el-button plain @click.native="$router.push('ssarea_list')">所属区域</el-button>
          <el-button plain @click.native="$router.push('gsscale_list')">公司规模</el-button>
          <el-button plain @click.native="$router.push('hdtax_list')">核定税种</el-button>
          <el-button plain @click.native="$router.push('sjcontent_list')">商机内容</el-button>
          <el-button plain @click.native="$router.push('sstax_list')">所属税务局</el-button>
          <el-button plain @click.native="$router.push('ssmarket_list')">所属市场局</el-button>
        </el-row>
        <el-row class="button-line">
          <el-button plain @click.native="$router.push('tsreason_list')">投诉原因</el-button>
          <el-button plain @click.native="$router.push('tyc_products')">产品管理</el-button>
          <el-button plain @click.native="$router.push('face_verified')">实名认证</el-button>
          <el-button plain @click.native="$router.push('order_platform')">订单平台来源</el-button>
          <el-button plain @click.native="$router.push('customer_belongs')">客户隶属</el-button>
          <el-button plain @click.native="$router.push('company_area')">公司区域管理</el-button>
          <el-button plain @click.native="$router.push('place_park')">落地园区管理</el-button>
        </el-row>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="text item">
        <el-row>
          <el-col class="title"><div class="grid-content bg-purple-dark">社保公积金</div></el-col>
        </el-row>
        <el-row class="button-line">
          <el-button plain @click.native="$router.push('any')">社保缴纳基数</el-button>
          <el-button plain @click.native="$router.push('any_accumulation')">公积金缴纳基数</el-button>
        </el-row>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="text item">
        <el-row>
          <el-col class="title"><div class="grid-content bg-purple-dark">后台管理</div></el-col>
        </el-row>
        <el-row class="button-line" id="admin-m">
          <el-button plain @click.native="$router.push('user')">用户管理</el-button>
          <el-button plain @click="$router.push('role_info')" style="margin-right: 0.2rem;">部门管理</el-button>
          <el-button plain @click.native="$router.push('authority')">角色管理</el-button>
          <el-button plain @click.native="$router.push('menus_manage')">菜单管理</el-button>
          <el-button plain @click.native="$router.push('client_manage')">会员等级管理</el-button>
          <el-button plain @click.native="$router.push('client_access')">会员权限管理</el-button>
          <el-button plain @click.native="$router.push('options')">基础信息</el-button>
<!--          <el-button plain @click.native="$router.push('logs')">后台操作日志</el-button>-->
<!--          <el-button plain @click.native="$router.push('work_diary')">工作日报</el-button>-->
        </el-row>
        <el-row class="button-line">
          <el-button plain @click.native="$router.push('msg_manage')">消息通知管理</el-button>
          <el-button plain @click.native="$router.push('moneyin_cate')">收款类型</el-button>
          <el-button plain @click.native="$router.push('check_setting')">目标考核配置管理</el-button>
          <el-button plain @click.native="$router.push('process_check')">考核过程参数配置</el-button>
          <el-button plain @click.native="$router.push('process_check_goal')">考核过程目标配置</el-button>
          <el-button plain @click.native="$router.push('financer_switch')">财税交接人员配置</el-button>
          <!-- <el-button plain @click.native="$router.push('company_server')">公司服务人员配置</el-button> -->
        </el-row>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="text item">
        <el-row>
          <el-col class="title"><div class="grid-content bg-purple-dark">内容管理</div></el-col>
        </el-row>
        <el-row class="button-line">
          <el-button plain @click.native="$router.push('flying_book')">公司文档管理</el-button>
          <el-button plain @click.native="$router.push('nav_body')">官网导航管理</el-button>
          <el-button plain @click.native="$router.push('bottom_body')">官网底部管理</el-button>
          <el-button plain @click.native="$router.push('mini_program_pic')">小程序图片管理</el-button>
          <el-button plain @click.native="$router.push('licence_manage')">许可证分类管理</el-button>
          <el-button plain @click.native="$router.push('alipay_promote_params_manage')">支付宝推广订单参数管理</el-button>
          <!-- <el-button plain @click.native="$router.push('soft_author')">软著申请列表（临时）</el-button> -->
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'SettingPanel',
  data () {
    return {
      foldStyle:{
        marginLeft: '1.25rem !important'
      },
      unFoldStyle:{
        marginLeft: '3.6rem !important'
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {}
}
</script>

<style scoped>
#admin-m button {
  margin-bottom: 0.2rem
}
.SettingPanel {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
.title {
  height: 0.3rem;
  font-size: 16px;
  margin-bottom: 0.2rem;
  color: #4d84fe;
  font-weight: bold;
}

.button-line {
  margin-bottom: 0.2rem;
}

.button-line a {
  margin-right: 10px;
}

.box-card {
  margin-bottom: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/SettingPanel.vue